module.exports = __webpack_public_path__ + "static/img/23_liuliang.9a2f18e9.png";